// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-tables-statistic-Directors-index__root","closedOrder":"src-components-tables-statistic-Directors-index__closedOrder"};